import React from 'react';
import { useLocale } from '@/i18n/LocaleProvider';
import { cn } from '@/lib/utils';

// TPC fair use (TPC Policies v6.20 §8.1.4, §8.1.5, §8.3.2, §8.3.3): every use of the TPC-H name for our own
// runs says "derived from", and the prescribed disclaimer sits wherever derived results are shown. The text
// below is §8.1.5's disclaimer verbatim; the deviations line is §8.3.2's; the last line is the attribution.
const text = {
  en: {
    disclaimer: 'This workload is derived from the TPC-H Benchmark and is not comparable to published TPC-H Benchmark results, as this implementation does not comply with all requirements of the TPC-H Benchmark.',
    deviations: 'Deviations: only the 22 queries are run (no refresh functions, no power or throughput test), timed as the sum of per-query means over three runs, without an audit.',
    trademark: 'TPC, TPC Benchmark and TPC-H are trademarks of the Transaction Processing Performance Council (TPC).',
  },
  'pt-BR': {
    disclaimer: 'Esta carga de trabalho é derivada do TPC-H Benchmark e não é comparável aos resultados publicados do TPC-H Benchmark, pois esta implementação não atende a todos os requisitos do TPC-H Benchmark.',
    deviations: 'Desvios: apenas as 22 consultas são executadas (sem funções de atualização, sem teste de potência ou de vazão), cronometradas como a soma das médias de cada consulta em três execuções, sem auditoria.',
    trademark: 'TPC, TPC Benchmark e TPC-H são marcas comerciais do Transaction Processing Performance Council (TPC).',
  },
};

/** The TPC fair-use footnote for a block that shows numbers from our TPC-H-derived runs. `deviations` adds
 *  how the run differs from the specification (for the 22-query timing runs, not the data-transfer tests). */
const TpcDisclaimer = ({ className, deviations = true }: { className?: string; deviations?: boolean }) => {
  const t = text[useLocale().locale];
  return (
    <p className={cn('text-xs leading-relaxed opacity-80', className)}>
      {t.disclaimer}{deviations ? ` ${t.deviations}` : ''} {t.trademark}
    </p>
  );
};

export default TpcDisclaimer;
